import { connect } from 'react-redux';

import { getIsHotelOnly } from 'src/store/view/selectors';
import { hasResults } from '../../../searchStatus/selectors';
import { getIsSubscribeShown, isFiltersHidden } from '../../../selectors/view';
import { isEmptyFiltrationSelector } from '../../../store/emptyFiltration/selectors';
import {
  isTopHotelNotFoundSelector,
  topHotelNameSelector,
} from '../../../store/hotels/selectors';
import SearchPageMobile from './SearchPageMobile';

const mapStateToProps = (state) => ({
  isHotelOnly: getIsHotelOnly(state),
  hideFilters: isFiltersHidden(state),
  isSubscribeShown: getIsSubscribeShown(state),
  isEmptyFiltration: isEmptyFiltrationSelector(state),
  hasSearchResults: hasResults(state),
  showNoTopHotel:
    isTopHotelNotFoundSelector(state) && !!topHotelNameSelector(state),
});

export default connect(mapStateToProps)(SearchPageMobile);
